<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">TBM Point</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #F2F2F2">
      <router-link to="/dashboard">Dashboard</router-link>/
      <b>Loyalty Point System</b> /
      <router-link to="/lps/charity-point">Charity Points</router-link> /
      <b>Details</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>

    <div class="row mb-4">
      <div class="col-md-12 mb-4">
        <!-- Active -->
        <div class="card text-left">
          <div class="card-body">
            <h4 class="card-title">Details</h4>
            <hr>

            <div class="col-8 offset-2">
              <div class="row" style="text-align: center;">
                <label class="col-5">BND: </label>
                <span class="col-2"></span>
                <label class="col-5">TBM Points: </label>
              </div>
              <div v-for="(rate, index) in rates" :key="index" class="row" style="text-align: center;">
                <input type="number" min="1" class="col-5 form-control mb-2" v-model="rate.price" @change="change(rate)">
                <span class="col-2"> = </span>
                <label class="col-5">{{rate.point}} </label>
              </div>
            </div>

            <div class="row" style="margin-top: 30px;">
              <div class="col-12 text-center">
                <button class="btn btn-rounded btn-primary col-3" @click="update()">Save</button>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>


<script>
// @ is an alias to /src
import axios from "axios";

export default {
  name: "charityPoint-edit",

  data() {
    return {
      rates: [],
      spend_rate: 0,
    };
  },

  methods: {
    loadPoint() {
      let token = localStorage.getItem("token");

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        axios
          .get(axios.lpsURL + "/charity_point", {
            headers: {
              Authorization: "Bearer " + token
            }
          })
          .then(res => {
            this.rates = res.data;
          })
      }
    },

    loadRate() {
      let token = localStorage.getItem("token");

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        axios
          .get(axios.lpsURL + "/rate", {
            headers: {
              Authorization: "Bearer " + token
            }
          })
          .then(res => {
            this.spend_rate = res.data.spend_rate;
          })
      }
    },

    change(rate){
      rate.point = rate.price * this.spend_rate
    },

    update(){
      let token = localStorage.getItem("token");

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;
        swal({
          icon: 'warning',
          text: 'Are you sure?',
          buttons: ['Cancel', 'Yes']
        }).then((confirm) => {
          if(!confirm) {
            return;
          }
          this.rates.forEach(rate => {
            
            axios.post(axios.lpsURL + "/charity_point/update/" + rate.id, 
              {
                price: rate.price
              },
              {
                headers: {
                  Authorization: "Bearer " + token
                }
              })
              .then(res => {
                swal({
                  icon: "success",
                  title: "Success",
                  text: res.data.message
                })
                .then(() => {
                  this.$router.push("/setting/charity-point")
                })
              })
          })
        })

      }
    }

  },


  mounted() {
    this.loadRate()
    this.loadPoint()
  }
};
</script>
